import { render, staticRenderFns } from "./AdviceBtn.vue?vue&type=template&id=74918cfa&scoped=true&"
import script from "./AdviceBtn.vue?vue&type=script&lang=js&"
export * from "./AdviceBtn.vue?vue&type=script&lang=js&"
import style0 from "./AdviceBtn.vue?vue&type=style&index=0&id=74918cfa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74918cfa",
  null
  
)

export default component.exports